import React, { useState } from 'react';
import {
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  CardMedia,
  IconButton,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack'; // eslint-disable-line no-unused-vars
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'; // eslint-disable-line no-unused-vars
import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/Info';
import PremiumHeader from '../../components/Header/PremiumHeader';
import { useLang, t } from '../../context/LanguageContext';
import T from '../../translations/index';

// Import work images
import work1 from '../../assets/works/work1.jpg';
import work2 from '../../assets/works/work2.jpg';
import work3 from '../../assets/works/work3.jpg';
import work4 from '../../assets/works/work4.jpg';
import work5 from '../../assets/works/work5.jpg';
import work6 from '../../assets/works/work6.jpg';
import work7 from '../../assets/works/work7.jpg';
import work8 from '../../assets/works/work8.jpg';
import work9 from '../../assets/works/work9.jpg';
import work10 from '../../assets/works/work10.jpg';

import '../common.css';
import './service.css';
import Footer from '../../components/Footer/Footer';

const ServicePage = () => {
  const navigate = useNavigate();
  const { lang } = useLang();
  const [galleryLightboxOpen, setGalleryLightboxOpen] = useState(false);
  const [selectedGalleryImage, setSelectedGalleryImage] = useState(null);
  const [selectedGalleryIndex, setSelectedGalleryIndex] = useState(0);

  // All Work Categories
  const constructionWorks = [
    {
      title: { en: 'Boiler Works', hi: 'बॉयलर कार्य' },
      description: { en: 'Complete scope of boiler-related works including piping, pressure parts, internal components, structural works, ducting, economizer, and APH installation.', hi: 'पाइपिंग, प्रेशर पार्ट्स, आंतरिक घटकों, संरचनात्मक कार्यों, डक्टिंग, इकोनोमाइज़र और APH स्थापना सहित बॉयलर संबंधी कार्यों का पूर्ण दायरा।' },
      subItems: [
        { name: { en: 'All Kind of Piping Works', hi: 'सभी प्रकार के पाइपिंग कार्य' }, details: { en: 'MS, CS, SS & Alloy steel pipes | Range: 25mm – 2000mm dia | SCH 20–160 | Welding, NDT & Hydro testing', hi: 'MS, CS, SS और मिश्र धातु इस्पात पाइप | रेंज: 25mm – 2000mm व्यास | SCH 20–160 | वेल्डिंग, NDT और हाइड्रो परीक्षण' }, manpower: { en: 'Fitter, Welder (IBR & Non-IBR), Rigger, Helper', hi: 'फिटर, वेल्डर (IBR और Non-IBR), रिगर, हेल्पर' } },
        { name: { en: 'Boiler Pressure Part (IBR) Works', hi: 'बॉयलर प्रेशर पार्ट (IBR) कार्य' }, details: { en: 'Headers, Steam Drums, Water Walls, Superheaters, Reheaters | Thickness 5mm–120mm | As per IBR code', hi: 'हेडर, स्टीम ड्रम, वाटर वॉल, सुपरहीटर, रिहीटर | मोटाई 5mm–120mm | IBR कोड के अनुसार' }, manpower: { en: 'IBR Certified Welders, QA/QC Engineer, Radiography Team', hi: 'IBR प्रमाणित वेल्डर, QA/QC इंजीनियर, रेडियोग्राफी टीम' } },
        { name: { en: 'Internal Components & Equipment Installation', hi: 'आंतरिक घटक और उपकरण स्थापना' }, details: { en: 'Water walls, Furnace panels, Burner assemblies, Superheater coils, Safety valves & Supports', hi: 'वाटर वॉल, फर्नेस पैनल, बर्नर असेंबली, सुपरहीटर कॉइल, सेफ्टी वाल्व और सपोर्ट' }, manpower: { en: 'Welder, Fitter, Millwright, Inspector', hi: 'वेल्डर, फिटर, मिलराइट, इंस्पेक्टर' } },
        { name: { en: 'Structural Works', hi: 'संरचनात्मक कार्य' }, details: { en: 'Boiler supporting structures, Columns, Beams, Platforms, Staircases up to 120m height', hi: 'बॉयलर सपोर्टिंग संरचनाएं, कॉलम, बीम, प्लेटफॉर्म, सीढ़ियां 120m ऊंचाई तक' }, manpower: { en: 'Fabricator, Structural Fitter, Welder, Rigger', hi: 'फैब्रिकेटर, स्ट्रक्चरल फिटर, वेल्डर, रिगर' } },
        { name: { en: 'Duct Management', hi: 'डक्ट प्रबंधन' }, details: { en: 'Flue gas ducts, Expansion joints, Dampers, Hopper ducts | Thickness 4mm–20mm', hi: 'फ्लू गैस डक्ट, एक्सपेंशन जॉइंट, डैम्पर, हॉपर डक्ट | मोटाई 4mm–20mm' }, manpower: { en: 'Fabricator, Gas Cutter, Welder, Erection Team', hi: 'फैब्रिकेटर, गैस कटर, वेल्डर, इरेक्शन टीम' } },
        { name: { en: 'Economizer Installation', hi: 'इकोनोमाइज़र स्थापना' }, details: { en: 'Tube bundles, Headers, Casings | Hydro testing & alignment', hi: 'ट्यूब बंडल, हेडर, कैसिंग | हाइड्रो परीक्षण और संरेखण' }, manpower: { en: 'Tube Welder, Fitter, QA/QC Inspector', hi: 'ट्यूब वेल्डर, फिटर, QA/QC इंस्पेक्टर' } },
        { name: { en: 'Air Pre-Heater (APH)', hi: 'एयर प्री-हीटर (APH)' }, details: { en: 'Rotary/Ljungstrom APH | Basket installation, Seals & Drive unit alignment', hi: 'रोटरी/ल्जुंगस्ट्रोम APH | बास्केट स्थापना, सील और ड्राइव यूनिट संरेखण' }, manpower: { en: 'Fitter, Welder, Millwright, Mechanical Supervisor', hi: 'फिटर, वेल्डर, मिलराइट, मैकेनिकल सुपरवाइज़र' } }
      ]
    },
    {
      title: { en: 'ESP-(Electrostatic Precipitator)', hi: 'ESP-(इलेक्ट्रोस्टेटिक प्रीसिपिटेटर)' },
      description: { en: 'Complete ESP works including hopper erection, equipment installation, and associated piping systems.', hi: 'हॉपर इरेक्शन, उपकरण स्थापना और संबंधित पाइपिंग प्रणालियों सहित पूर्ण ESP कार्य।' },
      subItems: [
        { name: { en: 'Hopper Installation', hi: 'हॉपर स्थापना' }, details: { en: 'ESP hoppers, discharge gates, insulation & alignment works', hi: 'ESP हॉपर, डिस्चार्ज गेट, इन्सुलेशन और संरेखण कार्य' }, manpower: { en: 'Fabricator, Fitter, Welder, Rigger', hi: 'फैब्रिकेटर, फिटर, वेल्डर, रिगर' } },
        { name: { en: 'Electrode Installation', hi: 'इलेक्ट्रोड स्थापना' }, details: { en: 'Discharge electrodes, Collecting electrodes, Emitting electrodes with alignment & tensioning', hi: 'डिस्चार्ज इलेक्ट्रोड, कलेक्टिंग इलेक्ट्रोड, एमिटिंग इलेक्ट्रोड संरेखण और तनाव सहित' }, manpower: { en: 'Electrode Fitter, Welder, QA/QC Inspector', hi: 'इलेक्ट्रोड फिटर, वेल्डर, QA/QC इंस्पेक्टर' } },
        { name: { en: 'GD Screen & Hampers', hi: 'GD स्क्रीन और हैम्पर' }, details: { en: 'Gas distribution (GD) screens, Hampers, Flow alignment works', hi: 'गैस वितरण (GD) स्क्रीन, हैम्पर, प्रवाह संरेखण कार्य' }, manpower: { en: 'Fitter, Gas Cutter, Fabricator, Supervisor', hi: 'फिटर, गैस कटर, फैब्रिकेटर, सुपरवाइज़र' } },
        { name: { en: 'Filter Bag & Internal Equipment', hi: 'फिल्टर बैग और आंतरिक उपकरण' }, details: { en: 'FF Bag installation, Casing internals, Seals, Access doors', hi: 'FF बैग स्थापना, कैसिंग इंटर्नल, सील, एक्सेस दरवाजे' }, manpower: { en: 'Filter Bag Technician, Welder, Helper, Safety Officer', hi: 'फिल्टर बैग तकनीशियन, वेल्डर, हेल्पर, सुरक्षा अधिकारी' } },
        { name: { en: 'Related Piping Works', hi: 'संबंधित पाइपिंग कार्य' }, details: { en: 'Ash handling piping, Cooling water piping, Compressed air piping | Range: 25mm – 600mm dia', hi: 'राख हैंडलिंग पाइपिंग, कूलिंग वाटर पाइपिंग, कंप्रेस्ड एयर पाइपिंग | रेंज: 25mm – 600mm व्यास' }, manpower: { en: 'Pipe Fabricator, IBR/Non-IBR Welder, Pipe Fitter, Helper', hi: 'पाइप फैब्रिकेटर, IBR/Non-IBR वेल्डर, पाइप फिटर, हेल्पर' } }
      ]
    },
    {
      title: { en: 'Coal Handling & Storage System', hi: 'कोयला हैंडलिंग और भंडारण प्रणाली' },
      description: { en: 'Works related to coal conveyors, crusher houses, stockyards and bunkers.', hi: 'कोयला कन्वेयर, क्रशर हाउस, स्टॉकयार्ड और बंकरों से संबंधित कार्य।' },
      subItems: [
        { name: { en: 'Conveyor System Installation', hi: 'कन्वेयर प्रणाली स्थापना' }, details: { en: 'Length: up to 5km | Belt width: 800–2000mm', hi: 'लंबाई: 5km तक | बेल्ट चौड़ाई: 800–2000mm' }, manpower: { en: 'Conveyor Erector, Fitter, Welder, Helper', hi: 'कन्वेयर इरेक्टर, फिटर, वेल्डर, हेल्पर' } },
        { name: { en: 'Crusher House Erection', hi: 'क्रशर हाउस निर्माण' }, details: { en: 'Structural + machine installation | Feed size: 300mm', hi: 'स्ट्रक्चरल + मशीन स्थापना | फीड साइज: 300mm' }, manpower: { en: 'Mechanical Fitter, Welder, Rigger', hi: 'मैकेनिकल फिटर, वेल्डर, रिगर' } },
        { name: { en: 'Coal Bunker Fabrication', hi: 'कोयला बंकर निर्माण' }, details: { en: 'Capacity: 1000–3000T | Mild steel fabrication', hi: 'क्षमता: 1000–3000T | माइल्ड स्टील फैब्रिकेशन' }, manpower: { en: 'Fabricator, Welder, Crane Operator', hi: 'फैब्रिकेटर, वेल्डर, क्रेन ऑपरेटर' } },
        { name: { en: 'Stacker & Reclaimer Works', hi: 'स्टैकर और रिक्लेमर कार्य' }, details: { en: 'Stacker boom length up to 40m | Reclaimer capacity 3000T/hr', hi: 'स्टैकर बूम लंबाई 40m तक | रिक्लेमर क्षमता 3000T/hr' }, manpower: { en: 'Heavy Mechanic, Electrical Fitter, Operator', hi: 'हेवी मैकेनिक, इलेक्ट्रिकल फिटर, ऑपरेटर' } },
        { name: { en: 'All Kind of Piping Works', hi: 'सभी प्रकार के पाइपिंग कार्य' }, details: { en: 'MS/CS/SS pipelines for dust suppression, firefighting & cooling water systems | Dia: 25mm – 1200mm', hi: 'धूल दमन, अग्निशमन और कूलिंग वाटर प्रणालियों के लिए MS/CS/SS पाइपलाइन | व्यास: 25mm – 1200mm' }, manpower: { en: 'Pipe Fitter, Welder, Rigger, Helper', hi: 'पाइप फिटर, वेल्डर, रिगर, हेल्पर' } }
      ]
    },
    {
      title: { en: 'Ash Management System', hi: 'राख प्रबंधन प्रणाली' },
      description: { en: 'Complete fly ash and bottom ash handling system including hoppers, silos, slurry & pneumatic pipelines, buffer storage, and associated equipment.', hi: 'हॉपर, साइलो, स्लरी और न्यूमेटिक पाइपलाइन, बफर स्टोरेज और संबंधित उपकरण सहित पूर्ण फ्लाई ऐश और बॉटम ऐश हैंडलिंग प्रणाली।' },
      subItems: [
        { name: { en: 'Bottom Ash Hopper Installation', hi: 'बॉटम ऐश हॉपर स्थापना' }, details: { en: 'Heavy steel hoppers with refractory lining | Hydraulic gate assembly, sealing & insulation works', hi: 'रिफ्रैक्टरी लाइनिंग के साथ भारी इस्पात हॉपर | हाइड्रोलिक गेट असेंबली, सीलिंग और इन्सुलेशन कार्य' }, manpower: { en: 'Fabricator, Welder, Rigger, Helper, QA/QC Inspector', hi: 'फैब्रिकेटर, वेल्डर, रिगर, हेल्पर, QA/QC इंस्पेक्टर' } },
        { name: { en: 'Buffer Hopper Works', hi: 'बफर हॉपर कार्य' }, details: { en: 'Intermediate ash storage hoppers for dry & wet systems | Liner plate fixing, expansion joints & valves', hi: 'सूखी और गीली प्रणालियों के लिए मध्यवर्ती राख भंडारण हॉपर | लाइनर प्लेट फिक्सिंग, एक्सपेंशन जॉइंट और वाल्व' }, manpower: { en: 'Welder, Structural Fitter, Fabricator, Supervisor', hi: 'वेल्डर, स्ट्रक्चरल फिटर, फैब्रिकेटर, सुपरवाइज़र' } },
        { name: { en: 'Ash Slurry Piping', hi: 'ऐश स्लरी पाइपिंग' }, details: { en: 'Slurry pipelines: Dia 200mm – 1000mm | MS/CI/Alloy pipes with bends, reducers, bends, pumps & hydro testing', hi: 'स्लरी पाइपलाइन: व्यास 200mm – 1000mm | MS/CI/मिश्र धातु पाइप बेंड, रिड्यूसर, पंप और हाइड्रो परीक्षण सहित' }, manpower: { en: 'IBR/Non-IBR Welder, Pipe Fitter, Pipe Layer, Helper', hi: 'IBR/Non-IBR वेल्डर, पाइप फिटर, पाइप लेयर, हेल्पर' } },
        { name: { en: 'ESP Ash Hopper Works', hi: 'ESP ऐश हॉपर कार्य' }, details: { en: 'Hopper plate replacement, expansion joints, pneumatic conveying connections', hi: 'हॉपर प्लेट प्रतिस्थापन, एक्सपेंशन जॉइंट, न्यूमेटिक कन्वेइंग कनेक्शन' }, manpower: { en: 'Fabricator, Welder, Helper, Rigger', hi: 'फैब्रिकेटर, वेल्डर, हेल्पर, रिगर' } },
        { name: { en: 'Ash Silos Construction', hi: 'ऐश साइलो निर्माण' }, details: { en: 'Height: 30m – 50m | Capacity: 1000MT – 2000MT | Fabrication, erection, aeration pads, unloading valves', hi: 'ऊंचाई: 30m – 50m | क्षमता: 1000MT – 2000MT | फैब्रिकेशन, इरेक्शन, एरेशन पैड, अनलोडिंग वाल्व' }, manpower: { en: 'Structural Fitter, Welder, Rigger, Crane Operator', hi: 'स्ट्रक्चरल फिटर, वेल्डर, रिगर, क्रेन ऑपरेटर' } },
        { name: { en: 'Pneumatic Ash Handling System', hi: 'न्यूमेटिक ऐश हैंडलिंग प्रणाली' }, details: { en: 'Compressor system, blowers, conveying pipelines, rotary feeders & valves | Pressure range 2 – 6kg/cm²', hi: 'कंप्रेसर प्रणाली, ब्लोअर, कन्वेइंग पाइपलाइन, रोटरी फीडर और वाल्व | दबाव रेंज 2 – 6kg/cm²' }, manpower: { en: 'Pipe Fitter, Instrument Technician, Welder, Helper', hi: 'पाइप फिटर, इंस्ट्रुमेंट तकनीशियन, वेल्डर, हेल्पर' } },
        { name: { en: 'Allied Equipment Installation', hi: 'संबद्ध उपकरण स्थापना' }, details: { en: 'Ash slurry pumps, ejectors, hydrocyclones, air compressors, expansion joints, supporting structures', hi: 'ऐश स्लरी पंप, इजेक्टर, हाइड्रोसाइक्लोन, एयर कंप्रेसर, एक्सपेंशन जॉइंट, सपोर्टिंग संरचनाएं' }, manpower: { en: 'Mechanical Fitter, Pump Technician, Welder, Safety Officer', hi: 'मैकेनिकल फिटर, पंप तकनीशियन, वेल्डर, सुरक्षा अधिकारी' } }
      ]
    },
    {
      title: { en: 'Cooling Tower Works', hi: 'कूलिंग टावर कार्य' },
      description: { en: 'Mechanical scope of cooling tower works including erection, piping, and associated equipment installation.', hi: 'इरेक्शन, पाइपिंग और संबंधित उपकरण स्थापना सहित कूलिंग टावर कार्यों का यांत्रिक दायरा।' },
      subItems: [
        { name: { en: 'Cooling Tower Mechanical Erection', hi: 'कूलिंग टावर यांत्रिक निर्माण' }, details: { en: 'FRP/Concrete towers | Mechanical assembly of fill media, drift eliminators, fan stacks & gearboxes', hi: 'FRP/कंक्रीट टावर | फिल मीडिया, ड्रिफ्ट एलिमिनेटर, फैन स्टैक और गियरबॉक्स की यांत्रिक असेंबली' }, manpower: { en: 'Cooling Tower Technician, Mechanical Fitter, Welder, Rigger', hi: 'कूलिंग टावर तकनीशियन, मैकेनिकल फिटर, वेल्डर, रिगर' } },
        { name: { en: 'Cooling Water Pipeline Works', hi: 'कूलिंग वाटर पाइपलाइन कार्य' }, details: { en: 'Large bore dia 1000mm – 3000mm | MS/CS/FRP underground & aboveground piping | Welding, hydro testing, supports', hi: 'बड़े बोर व्यास 1000mm – 3000mm | MS/CS/FRP भूमिगत और जमीन के ऊपर पाइपिंग | वेल्डिंग, हाइड्रो परीक्षण, सपोर्ट' }, manpower: { en: 'Pipe Fitter, IBR/Non-IBR Welder, Excavator Operator, Helper', hi: 'पाइप फिटर, IBR/Non-IBR वेल्डर, एक्सकेवेटर ऑपरेटर, हेल्पर' } },
        { name: { en: 'Fan Deck & Drive System Installation', hi: 'फैन डेक और ड्राइव सिस्टम स्थापना' }, details: { en: 'Installation of fan blades, shafts, gearboxes, bearings, motor alignment & balancing', hi: 'फैन ब्लेड, शाफ्ट, गियरबॉक्स, बेयरिंग, मोटर संरेखण और बैलेंसिंग की स्थापना' }, manpower: { en: 'Mechanical Fitter, Technician, Millwright, Electrician', hi: 'मैकेनिकल फिटर, तकनीशियन, मिलराइट, इलेक्ट्रीशियन' } },
        { name: { en: 'CT Basin Mechanical Works', hi: 'CT बेसिन यांत्रिक कार्य' }, details: { en: 'Pump installation, suction/discharge piping, strainers, valves, couplings & alignment', hi: 'पंप स्थापना, सक्शन/डिस्चार्ज पाइपिंग, स्ट्रेनर, वाल्व, कपलिंग और संरेखण' }, manpower: { en: 'Pump Technician, Pipe Fitter, Welder, Helper', hi: 'पंप तकनीशियन, पाइप फिटर, वेल्डर, हेल्पर' } },
        { name: { en: 'Associated Mechanical Equipment', hi: 'संबंधित यांत्रिक उपकरण' }, details: { en: 'Make-up water piping, chemical dosing system, blowdown piping & mechanical valves', hi: 'मेक-अप वाटर पाइपिंग, केमिकल डोजिंग सिस्टम, ब्लोडाउन पाइपिंग और मैकेनिकल वाल्व' }, manpower: { en: 'Pipe Fitter, Valve Technician, Welder, Supervisor', hi: 'पाइप फिटर, वाल्व तकनीशियन, वेल्डर, सुपरवाइज़र' } }
      ]
    },
    {
      title: { en: 'Chimney Works', hi: 'चिमनी कार्य' },
      description: { en: 'Mechanical scope of high-rise chimney works including shell erection, flue ducting, internal lining, and platforms.', hi: 'शेल इरेक्शन, फ्लू डक्टिंग, आंतरिक लाइनिंग और प्लेटफॉर्म सहित ऊंची चिमनी कार्यों का यांत्रिक दायरा।' },
      subItems: [
        { name: { en: 'Chimney Shell Erection (Steel)', hi: 'चिमनी शेल निर्माण (स्टील)' }, details: { en: 'Steel/RCC lined shell | Height up to 275m | Plate rolling, welding, lifting with cranes/winch systems', hi: 'स्टील/RCC लाइन्ड शेल | ऊंचाई 275m तक | प्लेट रोलिंग, वेल्डिंग, क्रेन/विंच सिस्टम से उठाना' }, manpower: { en: 'High-rise Rigger, Structural Welder, Fabricator, Crane Operator', hi: 'हाई-राइज रिगर, स्ट्रक्चरल वेल्डर, फैब्रिकेटर, क्रेन ऑपरेटर' } },
        { name: { en: 'Flue Gas Ducting & Expansion Joints', hi: 'फ्लू गैस डक्टिंग और एक्सपेंशन जॉइंट' }, details: { en: 'Heavy steel ducts | Size up to 10m x 8m | Welding, insulation, supports & expansion joint fixing', hi: 'भारी इस्पात डक्ट | आकार 10m x 8m तक | वेल्डिंग, इन्सुलेशन, सपोर्ट और एक्सपेंशन जॉइंट फिक्सिंग' }, manpower: { en: 'Fabricator, Welder, Duct Erector, Insulation Fitter', hi: 'फैब्रिकेटर, वेल्डर, डक्ट इरेक्टर, इन्सुलेशन फिटर' } },
        { name: { en: 'Chimney Lining (Mechanical Scope)', hi: 'चिमनी लाइनिंग (यांत्रिक दायरा)' }, details: { en: 'Refractory/acid-resistant brick lining, steel anchors, casing supports, insulation', hi: 'रिफ्रैक्टरी/एसिड-प्रतिरोधी ईंट लाइनिंग, स्टील एंकर, कैसिंग सपोर्ट, इन्सुलेशन' }, manpower: { en: 'Refractory Mason, Welder (for anchors), Helper, Safety Officer', hi: 'रिफ्रैक्टरी मेसन, वेल्डर (एंकर के लिए), हेल्पर, सुरक्षा अधिकारी' } },
        { name: { en: 'Platforms, Ladders & Cages', hi: 'प्लेटफॉर्म, सीढ़ियां और पिंजरे' }, details: { en: 'Steel platforms, access ladders, spiral staircases, safety cages, handrails up to chimney top', hi: 'स्टील प्लेटफॉर्म, एक्सेस सीढ़ियां, सर्पिल सीढ़ियां, सेफ्टी केज, हैंडरेल चिमनी के शीर्ष तक' }, manpower: { en: 'Fitter, Structural Welder, High-rise Rigger, Safety Inspector', hi: 'फिटर, स्ट्रक्चरल वेल्डर, हाई-राइज रिगर, सुरक्षा इंस्पेक्टर' } },
        { name: { en: 'Associated Mechanical Works', hi: 'संबद्ध यांत्रिक कार्य' }, details: { en: 'Flue gas dampers, guillotine gates, bypass duct connections, manhole covers & bolted joints', hi: 'फ्लू गैस डैम्पर, गिलोटिन गेट, बाईपास डक्ट कनेक्शन, मैनहोल कवर और बोल्टेड जॉइंट' }, manpower: { en: 'Mechanical Fitter, Welder, Fabricator, Supervisor', hi: 'मैकेनिकल फिटर, वेल्डर, फैब्रिकेटर, सुपरवाइज़र' } }
      ]
    },
    {
      title: { en: 'FGD - Flue Gas Desulfurization', hi: 'FGD - फ्लू गैस डीसल्फराइज़ेशन' },
      description: { en: 'Mechanical works for FGD system including absorber erection, recycle pump headers, duct supports, and complete piping works.', hi: 'एब्जॉर्बर इरेक्शन, रिसाइकिल पंप हेडर, डक्ट सपोर्ट और पूर्ण पाइपिंग कार्यों सहित FGD प्रणाली के लिए यांत्रिक कार्य।' },
      subItems: [
        { name: { en: 'DSS - Duct Structure Support', hi: 'DSS - डक्ट स्ट्रक्चर सपोर्ट' }, details: { en: 'Heavy steel structures for flue gas ducts | Height: 10m – 60m | Beams, columns, bracings & platforms', hi: 'फ्लू गैस डक्ट के लिए भारी इस्पात संरचनाएं | ऊंचाई: 10m – 60m | बीम, कॉलम, ब्रेसिंग और प्लेटफॉर्म' }, manpower: { en: 'Structural Fitter, Welder, Rigger, Fabricator', hi: 'स्ट्रक्चरल फिटर, वेल्डर, रिगर, फैब्रिकेटर' } },
        { name: { en: 'Duct Supporting Structure & Ducting', hi: 'डक्ट सपोर्टिंग स्ट्रक्चर और डक्टिंग' }, details: { en: 'Flue gas duct fabrication & erection | Size up to 10m x 8m | Expansion joints, dampers & insulation', hi: 'फ्लू गैस डक्ट फैब्रिकेशन और इरेक्शन | आकार 10m x 8m तक | एक्सपेंशन जॉइंट, डैम्पर और इन्सुलेशन' }, manpower: { en: 'Fabricator, Gas Cutter, Welder, Insulation Fitter', hi: 'फैब्रिकेटर, गैस कटर, वेल्डर, इन्सुलेशन फिटर' } },
        { name: { en: 'RCPH - Recycle Pump Header Works', hi: 'RCPH - रिसाइकिल पंप हेडर कार्य' }, details: { en: 'Recycle pump header piping & support structure | Large bore dia 500mm – 2000mm | Pump suction & discharge lines', hi: 'रिसाइकिल पंप हेडर पाइपिंग और सपोर्ट स्ट्रक्चर | बड़े बोर व्यास 500mm – 2000mm | पंप सक्शन और डिस्चार्ज लाइन' }, manpower: { en: 'Pipe Fitter, IBR/Non-IBR Welder, Pump Technician, Helper', hi: 'पाइप फिटर, IBR/Non-IBR वेल्डर, पंप तकनीशियन, हेल्पर' } },
        { name: { en: 'Absorber / Scrubber Installation', hi: 'एब्जॉर्बर / स्क्रबर स्थापना' }, details: { en: 'FRP/RCC absorber tower erection | Mist eliminator, spray nozzles, agitators & internals installation', hi: 'FRP/RCC एब्जॉर्बर टावर इरेक्शन | मिस्ट एलिमिनेटर, स्प्रे नोज़ल, एजिटेटर और इंटर्नल स्थापना' }, manpower: { en: 'Mechanical Fitter, FRP Technician, Welder, Rigger', hi: 'मैकेनिकल फिटर, FRP तकनीशियन, वेल्डर, रिगर' } },
        { name: { en: 'All Types of Piping Works', hi: 'सभी प्रकार के पाइपिंग कार्य' }, details: { en: 'Slurry piping, sea water piping, limestone piping, gypsum disposal piping | Dia: 25mm – 2000mm | Hydro testing & flushing', hi: 'स्लरी पाइपिंग, समुद्री जल पाइपिंग, चूना पत्थर पाइपिंग, जिप्सम निपटान पाइपिंग | व्यास: 25mm – 2000mm | हाइड्रो परीक्षण और फ्लशिंग' }, manpower: { en: 'Pipe Fabricator, Welder, QA/QC Engineer, Helper', hi: 'पाइप फैब्रिकेटर, वेल्डर, QA/QC इंजीनियर, हेल्पर' } },
        { name: { en: 'Associated Mechanical Equipment', hi: 'संबद्ध यांत्रिक उपकरण' }, details: { en: 'Recycle pumps, agitators, oxidation blowers, slurry tanks & support structures', hi: 'रिसाइकिल पंप, एजिटेटर, ऑक्सीडेशन ब्लोअर, स्लरी टैंक और सपोर्ट संरचनाएं' }, manpower: { en: 'Pump Technician, Mechanical Fitter, Welder, Supervisor', hi: 'पंप तकनीशियन, मैकेनिकल फिटर, वेल्डर, सुपरवाइज़र' } }
      ]
    },
    {
      title: { en: 'Shutdown Works', hi: 'शटडाउन कार्य' },
      description: { en: 'Comprehensive planned shutdown works covering boiler, turbine, ESP, auxiliaries, piping, electrical & instrumentation systems with inspection, overhaul and rectification.', hi: 'बॉयलर, टर्बाइन, ESP, सहायक उपकरण, पाइपिंग, विद्युत और इंस्ट्रुमेंटेशन प्रणालियों की निरीक्षण, ओवरहॉल और सुधार सहित व्यापक नियोजित शटडाउन कार्य।' },
      subItems: [
        { name: { en: 'Boiler Overhaul', hi: 'बॉयलर ओवरहॉल' }, details: { en: 'Water wall & superheater/reheater tube replacement, header & drum inspection, soot blower maintenance, refractory & insulation repairs, burner overhauling | Duration: 15–30 days', hi: 'वाटर वॉल और सुपरहीटर/रिहीटर ट्यूब प्रतिस्थापन, हेडर और ड्रम निरीक्षण, सूट ब्लोअर रखरखाव, रिफ्रैक्टरी और इन्सुलेशन मरम्मत, बर्नर ओवरहॉलिंग | अवधि: 15–30 दिन' }, manpower: { en: 'Boilermaker, IBR Welder, QA/QC Inspector, Scaffolder, Rigger', hi: 'बॉयलरमेकर, IBR वेल्डर, QA/QC इंस्पेक्टर, स्कैफोल्डर, रिगर' } },
        { name: { en: 'Turbine Overhaul', hi: 'टर्बाइन ओवरहॉल' }, details: { en: 'Rotor & casing inspection, blade replacement, diaphragm cleaning, gland seal checks, bearing replacement, alignment & balancing | Unit size: 120MW – 800MW', hi: 'रोटर और केसिंग निरीक्षण, ब्लेड प्रतिस्थापन, डायाफ्राम सफाई, ग्लैंड सील जांच, बेयरिंग प्रतिस्थापन, संरेखण और बैलेंसिंग | यूनिट आकार: 120MW – 800MW' }, manpower: { en: 'Turbine Fitter, Millwright, Alignment Engineer, QA Engineer', hi: 'टर्बाइन फिटर, मिलराइट, संरेखण इंजीनियर, QA इंजीनियर' } },
        { name: { en: 'ESP Maintenance', hi: 'ESP रखरखाव' }, details: { en: 'Electrode replacement (collecting & emitting), rapping system repair, hopper sealing, GD screen cleaning, rectifier transformer servicing', hi: 'इलेक्ट्रोड प्रतिस्थापन (कलेक्टिंग और एमिटिंग), रैपिंग सिस्टम मरम्मत, हॉपर सीलिंग, GD स्क्रीन सफाई, रेक्टिफायर ट्रांसफॉर्मर सर्विसिंग' }, manpower: { en: 'Welder, ESP Fitter, Electrician, Helper', hi: 'वेल्डर, ESP फिटर, इलेक्ट्रीशियन, हेल्पर' } },
        { name: { en: 'Auxiliary Equipments', hi: 'सहायक उपकरण' }, details: { en: 'Overhauling of ID/FD/PA fans, cooling water pumps, ash slurry pumps, heat exchangers, compressors, gearboxes, lubrication systems', hi: 'ID/FD/PA फैन, कूलिंग वाटर पंप, ऐश स्लरी पंप, हीट एक्सचेंजर, कंप्रेसर, गियरबॉक्स, लुब्रिकेशन सिस्टम का ओवरहॉलिंग' }, manpower: { en: 'Pump Technician, Fan Erector, Mechanical Fitter, Electrician', hi: 'पंप तकनीशियन, फैन इरेक्टर, मैकेनिकल फिटर, इलेक्ट्रीशियन' } },
        { name: { en: 'Piping Works', hi: 'पाइपिंग कार्य' }, details: { en: 'IBR piping inspection, weld joint radiography, valve overhauling, hydro testing of HP/LP lines, drain & vent system rectification', hi: 'IBR पाइपिंग निरीक्षण, वेल्ड जॉइंट रेडियोग्राफी, वाल्व ओवरहॉलिंग, HP/LP लाइनों का हाइड्रो परीक्षण, ड्रेन और वेंट सिस्टम सुधार' }, manpower: { en: 'IBR Welder, Pipe Fitter, Radiography Team, QA Inspector', hi: 'IBR वेल्डर, पाइप फिटर, रेडियोग्राफी टीम, QA इंस्पेक्टर' } },
        { name: { en: 'Coal Handling System Maintenance', hi: 'कोयला हैंडलिंग प्रणाली रखरखाव' }, details: { en: 'Conveyor belt replacement, pulley & gearbox inspection, crusher overhaul, stacker/reclaimer servicing', hi: 'कन्वेयर बेल्ट प्रतिस्थापन, पुली और गियरबॉक्स निरीक्षण, क्रशर ओवरहॉल, स्टैकर/रिक्लेमर सर्विसिंग' }, manpower: { en: 'Mechanical Fitter, Conveyor Technician, Rigger, Welder', hi: 'मैकेनिकल फिटर, कन्वेयर तकनीशियन, रिगर, वेल्डर' } },
        { name: { en: 'Ash Handling System Maintenance', hi: 'राख हैंडलिंग प्रणाली रखरखाव' }, details: { en: 'Bottom ash hopper cleaning, slurry pipeline inspection, silo maintenance, pneumatic conveying equipment servicing', hi: 'बॉटम ऐश हॉपर सफाई, स्लरी पाइपलाइन निरीक्षण, साइलो रखरखाव, न्यूमेटिक कन्वेइंग उपकरण सर्विसिंग' }, manpower: { en: 'Pipe Fitter, Welder, Pump Technician, Helper', hi: 'पाइप फिटर, वेल्डर, पंप तकनीशियन, हेल्पर' } },
        { name: { en: 'Cooling Tower Maintenance', hi: 'कूलिंग टावर रखरखाव' }, details: { en: 'Fan overhaul, gearbox alignment, fill media & drift eliminator replacement, basin cleaning & pump rectification', hi: 'फैन ओवरहॉल, गियरबॉक्स संरेखण, फिल मीडिया और ड्रिफ्ट एलिमिनेटर प्रतिस्थापन, बेसिन सफाई और पंप सुधार' }, manpower: { en: 'Cooling Tower Technician, Pump Fitter, Mechanical Fitter, Rigger', hi: 'कूलिंग टावर तकनीशियन, पंप फिटर, मैकेनिकल फिटर, रिगर' } },
        { name: { en: 'Chimney Works', hi: 'चिमनी कार्य' }, details: { en: 'Liner inspection, refractory patching, platform & ladder repair, expansion joint replacement', hi: 'लाइनर निरीक्षण, रिफ्रैक्टरी पैचिंग, प्लेटफॉर्म और सीढ़ी मरम्मत, एक्सपेंशन जॉइंट प्रतिस्थापन' }, manpower: { en: 'High-rise Rigger, Welder, Refractory Mason, Safety Officer', hi: 'हाई-राइज रिगर, वेल्डर, रिफ्रैक्टरी मेसन, सुरक्षा अधिकारी' } },
        { name: { en: 'Electrical Shutdown Works', hi: 'विद्युत शटडाउन कार्य' }, details: { en: 'HT/LT motor overhauling, transformer oil filtration, breaker maintenance, cable IR testing, earthing system inspection', hi: 'HT/LT मोटर ओवरहॉलिंग, ट्रांसफॉर्मर ऑयल फिल्ट्रेशन, ब्रेकर रखरखाव, केबल IR परीक्षण, अर्थिंग सिस्टम निरीक्षण' }, manpower: { en: 'Electrical Fitter, HV Technician, Cable Jointers, Safety Inspector', hi: 'इलेक्ट्रिकल फिटर, HV तकनीशियन, केबल जॉइंटर, सुरक्षा इंस्पेक्टर' } },
        { name: { en: 'Instrumentation & Control Works', hi: 'इंस्ट्रुमेंटेशन और नियंत्रण कार्य' }, details: { en: 'Calibration of transmitters, control valves, DCS/PLC loop checking, turbine governing system testing, soot blower automation check', hi: 'ट्रांसमिटर कैलिब्रेशन, कंट्रोल वाल्व, DCS/PLC लूप जांच, टर्बाइन गवर्निंग सिस्टम परीक्षण, सूट ब्लोअर ऑटोमेशन जांच' }, manpower: { en: 'Instrument Technician, Control Engineer, Panel Fitter, Wireman', hi: 'इंस्ट्रुमेंट तकनीशियन, कंट्रोल इंजीनियर, पैनल फिटर, वायरमैन' } },
        { name: { en: 'Safety Preparations & Support', hi: 'सुरक्षा तैयारी और सहायता' }, details: { en: 'Scaffolding erection, confined space entry management, gas monitoring, fire watch & safety audit', hi: 'स्कैफोल्डिंग निर्माण, सीमित स्थान प्रवेश प्रबंधन, गैस निगरानी, फायर वॉच और सुरक्षा ऑडिट' }, manpower: { en: 'Scaffolder, Safety Officer, Gas Tester, Fireman', hi: 'स्कैफोल्डर, सुरक्षा अधिकारी, गैस टेस्टर, फायरमैन' } }
      ]
    }
  ];

  const projectImages = [work1, work2, work3, work4, work5, work6, work7, work8, work9, work10];

  // eslint-disable-next-line no-unused-vars
  const handleNavClick = (e, path) => {
    e.preventDefault();
    
    switch (path) {
      case 'home':
        navigate('/');
        break;
      case 'about':
        navigate('/about');
        break;
      case 'services':
        navigate('/services');
        break;
      case 'projects':
        navigate('/projects');
        break;
      case 'clients':
        navigate('/clients');
        break;
      case 'careers':
        navigate('/careers');
        break;
      case 'hireus':
        navigate('/hireus');
        break;
      case 'contact':
        navigate('/contact');
        break;
      default:
        break;
    }
  };

  // Gallery Lightbox Handlers
  const handleGalleryImageClick = (image, index) => {
    setSelectedGalleryImage(image);
    setSelectedGalleryIndex(index);
    setGalleryLightboxOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const handleCloseGalleryLightbox = () => {
    setGalleryLightboxOpen(false);
    setSelectedGalleryImage(null);
    document.body.style.overflow = 'auto';
  };

  const handleGalleryBackdropClick = (e) => {
    if (e.target.className === 'gallery-lightbox-backdrop') {
      handleCloseGalleryLightbox();
    }
  };

  const handlePrevImage = () => {
    const newIndex = selectedGalleryIndex === 0 ? projectImages.length - 1 : selectedGalleryIndex - 1;
    setSelectedGalleryIndex(newIndex);
    setSelectedGalleryImage(projectImages[newIndex]);
  };

  const handleNextImage = () => {
    const newIndex = selectedGalleryIndex === projectImages.length - 1 ? 0 : selectedGalleryIndex + 1;
    setSelectedGalleryIndex(newIndex);
    setSelectedGalleryImage(projectImages[newIndex]);
  };

  // Handle ESC key to close lightbox
  React.useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && galleryLightboxOpen) {
        handleCloseGalleryLightbox();
      }
      if (e.key === 'ArrowLeft' && galleryLightboxOpen) {
        handlePrevImage();
      }
      if (e.key === 'ArrowRight' && galleryLightboxOpen) {
        handleNextImage();
      }
    };

    if (galleryLightboxOpen) {
      window.addEventListener('keydown', handleKeyDown);
      return () => window.removeEventListener('keydown', handleKeyDown);
    }
  }, [galleryLightboxOpen, selectedGalleryIndex]);

  return (
    <div className="routed-page">
      <PremiumHeader />

      <div className="page-header-section">
        <Typography className="page-title">
          {t(T.servicesPageTitle, lang)}
        </Typography>
          <Typography className="page-subtitle">
            {t(T.servicesPageSubtitle, lang)}
          </Typography>
        </div>

      <div className="page-container content-wrapper">
        {/* All Work Categories */}
        <Grid
          container
          spacing={3}
          className="dashboard-sections"
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
            gap: '24px',
          }}
        >
          {constructionWorks.map((category, index) => (
            <Grid item key={index}>
              <ExpandableListCard category={category} lang={lang} />
            </Grid>
          ))}
        </Grid>

        {/* Project Gallery Showcase */}
        <Box className="project-showcase-section">
          <Typography variant="h5" className="showcase-title">
            {t(T.projectExpertiseTitle, lang)}
          </Typography>
          <Typography variant="body1" className="showcase-subtitle">
            {t(T.projectExpertiseSub, lang)}
          </Typography>
          
          <Grid container spacing={2} className="project-showcase-grid">
            {projectImages.map((image, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Card className="showcase-card" onClick={() => handleGalleryImageClick(image, index)}>
                  <CardMedia
                    component="img"
                    height="220"
                    image={image}
                    alt={`Project ${index + 1}`}
                    className="showcase-image"
                  />
                </Card>
              </Grid>
            ))}
          </Grid>

          <Box className="view-all-projects">
            <Button 
              variant="contained" 
              color="primary"
              onClick={() => navigate('/projects')}
              className="view-projects-btn"
            >
              {t(T.viewAllProjects, lang)}
            </Button>
          </Box>
        </Box>

        {/* Gallery Lightbox Modal */}
        {galleryLightboxOpen && (
          <div className="gallery-lightbox-backdrop" onClick={handleGalleryBackdropClick}>
            <div className="gallery-lightbox-container">
              <button className="gallery-lightbox-close" onClick={handleCloseGalleryLightbox}>
                ✕
              </button>
              <div className="gallery-lightbox-content">
                <img src={selectedGalleryImage} alt="enlarged" className="gallery-lightbox-image" />
              </div>
              <button className="gallery-lightbox-nav gallery-lightbox-prev" onClick={handlePrevImage}>
                ❮
              </button>
              <button className="gallery-lightbox-nav gallery-lightbox-next" onClick={handleNextImage}>
                ❯
              </button>
              <div className="gallery-lightbox-counter">
                {selectedGalleryIndex + 1} / {projectImages.length}
              </div>
            </div>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

// Expandable List Card with Modal Dialog
const ExpandableListCard = ({ category, lang }) => {
  const [openModal, setOpenModal] = useState(false);
  const safeLang = lang || 'en';

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const getVal = (field) => typeof field === 'object' ? (field[safeLang] || field.en) : field;

  return (
    <>
      <Card className="dashboard-card">
        <CardContent className="card-content-wrapper">
          <div className="card-header">
            <Typography variant="h6" className="section-title">
              {getVal(category.title)}
            </Typography>
            <IconButton
              className="expand-icon"
              onClick={handleOpenModal}
              size="small"
              title="View Details"
            >
              <InfoIcon />
            </IconButton>
          </div>

          <Typography variant="body2" className="category-description">
            {getVal(category.description)}
          </Typography>
        </CardContent>
      </Card>

      {/* Modal Dialog for Service Details */}
      <Dialog 
        open={openModal} 
        onClose={handleCloseModal}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '22px',
            boxShadow: '0 28px 90px rgba(23,60,170,0.24), 0 6px 24px rgba(0,0,0,0.10)',
            overflow: 'hidden',
            background: '#ffffff',
          }
        }}
      >
        {/* ── Header ── */}
        <DialogTitle sx={{ p: 0,
          background: 'linear-gradient(135deg, #173caa 0%, #1e5ce6 60%, #4d8aff 100%)',
          position: 'relative',
          overflow: 'hidden',
          '&::after': {
            content: '""', position: 'absolute', inset: 0,
            background: 'linear-gradient(135deg, rgba(255,255,255,0.12) 0%, transparent 60%)',
            pointerEvents: 'none',
          }
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', px: 3.5, pt: 3, pb: 0.5 }}>
            <Typography sx={{ fontWeight: 800, fontSize: '1.25rem', color: '#fff', lineHeight: 1.3, letterSpacing: '-0.3px', pr: 2 }}>
              {getVal(category.title)}
            </Typography>
            <IconButton
              onClick={handleCloseModal}
              size="small"
              sx={{
                color: 'rgba(255,255,255,0.8)',
                background: 'rgba(255,255,255,0.12)',
                borderRadius: '50%',
                flexShrink: 0,
                mt: 0.25,
                transition: 'all 0.22s ease',
                '&:hover': { background: 'rgba(255,255,255,0.22)', color: '#fff', transform: 'rotate(90deg)' }
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
          <Typography sx={{ px: 3.5, pb: 2.5, pt: 0.75, fontSize: '0.87rem', color: 'rgba(255,255,255,0.74)', lineHeight: 1.6 }}>
            {getVal(category.description)}
          </Typography>
        </DialogTitle>

        {/* ── Content ── */}
        <DialogContent sx={{ p: 0, background: '#f8faff' }}>
          <Box sx={{ p: '22px 22px 10px' }} className="expanded-content">
            {category.subItems.map((item, idx) => (
              <Box key={idx} sx={{
                mb: 1.5,
                p: '16px 18px',
                borderRadius: '14px',
                background: '#ffffff',
                border: '1.5px solid #e8eef8',
                transition: 'all 0.22s ease',
                '&:hover': { borderColor: '#b8caee', boxShadow: '0 4px 18px rgba(23,60,170,0.09)', transform: 'translateX(4px)' }
              }}>
                {/* Sub-item title */}
                <Typography sx={{
                  fontWeight: 700, fontSize: '0.95rem', color: '#173caa',
                  mb: 1.25, letterSpacing: '-0.1px',
                }}>
                  {getVal(item.name)}
                </Typography>
                {/* Details row */}
                <Box sx={{ display: 'flex', gap: 1.25, mb: 0.75, alignItems: 'flex-start' }}>
                  <Typography component="span" sx={{
                    fontSize: '0.71rem', fontWeight: 700, color: '#fff',
                    background: 'linear-gradient(135deg,#173caa,#1e5ce6)',
                    px: '8px', py: '2.5px', borderRadius: '6px',
                    flexShrink: 0, mt: '2px', letterSpacing: '0.4px', textTransform: 'uppercase'
                  }}>{safeLang === 'hi' ? 'विवरण' : 'Details'}</Typography>
                  <Typography sx={{ fontSize: '0.86rem', color: '#3d4f6e', lineHeight: 1.65 }}>
                    {getVal(item.details)}
                  </Typography>
                </Box>
                {/* Manpower row */}
                <Box sx={{ display: 'flex', gap: 1.25, alignItems: 'flex-start' }}>
                  <Typography component="span" sx={{
                    fontSize: '0.71rem', fontWeight: 700, color: '#fff',
                    background: 'linear-gradient(135deg,#0d9488,#14b8a6)',
                    px: '8px', py: '2.5px', borderRadius: '6px',
                    flexShrink: 0, mt: '2px', letterSpacing: '0.4px', textTransform: 'uppercase'
                  }}>{safeLang === 'hi' ? 'टीम' : 'Team'}</Typography>
                  <Typography sx={{ fontSize: '0.86rem', color: '#3d4f6e', lineHeight: 1.65 }}>
                    {getVal(item.manpower)}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
        </DialogContent>

        {/* ── Footer ── */}
        <DialogActions sx={{ px: 3, py: 2.5, background: '#f8faff', borderTop: '1.5px solid #e8eef8' }}>
          <Button 
            onClick={handleCloseModal}
            variant="contained"
            sx={{
              background: 'linear-gradient(135deg,#173caa 0%,#1e5ce6 60%,#4d8aff 100%)',
              color: '#fff',
              fontWeight: 700,
              textTransform: 'none',
              borderRadius: '50px',
              px: 4,
              py: 1.1,
              fontSize: '0.93rem',
              border: 'none',
              boxShadow: '0 4px 18px rgba(23,60,170,0.32)',
              position: 'relative',
              overflow: 'hidden',
              '&::before': {
                content: '""', position: 'absolute', inset: 0,
                background: 'linear-gradient(135deg,rgba(255,255,255,0.18) 0%,transparent 55%)',
                borderRadius: 'inherit', pointerEvents: 'none',
              },
              '&:hover': {
                background: 'linear-gradient(135deg,#0d2d8a 0%,#173caa 55%,#1e5ce6 100%)',
                boxShadow: '0 10px 28px rgba(23,60,170,0.46)',
                transform: 'translateY(-2px) scale(1.03)',
              }
            }}
          >
            {safeLang === 'hi' ? 'बंद करें' : 'Close'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ServicePage;
